/*!
 * Copyright (c) 2017-present Ghostery GmbH. All rights reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
/* eslint-disable prettier/prettier */
export default [
    ".actonservi",
    "/js/sdkload",
    "^https:\\/\\/",
    "||smetrics.",
    "third-party",
    "xmlhttprequ",
    "-rule=noop",
    "marketing.",
    ",redirect",
    ".website^",
    "analytics",
    ",domain=",
    ".online^",
    "document",
    "metrics.",
    "tracking",
    ".space^",
    "$script",
    ".co.uk",
    ".cyou^",
    ".qpon^",
    ".shop^",
    ".site^",
    "a8clk.",
    "cookie",
    "google",
    "script",
    ".cfd^",
    ".com^",
    ".pro^",
    ".xyz^",
    "[a-z]",
    "/wp-c",
    "$doma",
    "a8cv.",
    "image",
    "media",
    "track",
    ".au^",
    ".com",
    ".fr^",
    ".gif",
    ".jp^",
    ".net",
    ".php",
    "/js/",
    "$doc",
    "$xhr",
    "www.",
    ",1p",
    ",3p",
    ".js",
    "%2F",
    "cdn",
    "web",
    ".b",
    ".c",
    ".m",
    ".n",
    ".p",
    ".t",
    "@@",
    "/*",
    "/p",
    "^$",
    "||",
    "a-",
    "ab",
    "ac",
    "ad",
    "af",
    "ag",
    "ak",
    "al",
    "am",
    "an",
    "ap",
    "ar",
    "as",
    "at",
    "au",
    "av",
    "aw",
    "ax",
    "ay",
    "az",
    "be",
    "bl",
    "bo",
    "br",
    "ca",
    "ce",
    "ch",
    "ck",
    "cl",
    "cr",
    "ct",
    "de",
    "di",
    "do",
    "dr",
    "ds",
    "e-",
    "eb",
    "ec",
    "ed",
    "el",
    "em",
    "en",
    "ep",
    "er",
    "es",
    "et",
    "ev",
    "ew",
    "ex",
    "ey",
    "fa",
    "ff",
    "fi",
    "fl",
    "fo",
    "fr",
    "g^",
    "ge",
    "go",
    "gr",
    "he",
    "hi",
    "ho",
    "ht",
    "ic",
    "id",
    "ie",
    "if",
    "ig",
    "ik",
    "il",
    "im",
    "in",
    "io",
    "ip",
    "ir",
    "is",
    "it",
    "iv",
    "ix",
    "iz",
    "js",
    "le",
    "li",
    "lo",
    "ly",
    "ma",
    "me",
    "mo",
    "mp",
    "my",
    "no",
    "od",
    "ok",
    "ol",
    "om",
    "on",
    "op",
    "or",
    "ot",
    "pl",
    "po",
    "pr",
    "qu",
    "re",
    "ro",
    "ru",
    "s/",
    "sc",
    "se",
    "sh",
    "si",
    "sk",
    "so",
    "sp",
    "ss",
    "st",
    "sw",
    "sy",
    "te",
    "th",
    "ti",
    "to",
    "tr",
    "ts",
    "ty",
    "ub",
    "ud",
    "ug",
    "ul",
    "um",
    "un",
    "up",
    "ur",
    "us",
    "ut",
    "ve",
    "vi",
    "_",
    "-",
    ",",
    "?",
    ".",
    "*",
    "/",
    "\\",
    "^",
    "=",
    "|",
    "~",
    "$",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z"
];
//# sourceMappingURL=raw-network.js.map